import React, { useState, useEffect } from 'react';
import { IconButton, Badge, Menu, MenuItem } from '@mui/material';
import { useRestApi } from 'context/RestApiContext';
import './TaskCards.css';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { HISTORY_TYPE } from 'constants/constants';

// 新着アイコンボタン
const TaskNewNotificationButtonIcon = (props) => {
  const restApi = useRestApi();

  const [newComments, setNewComments] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null); // メニューの表示位置を管理
  const [newFlg, setNewFlg] = useState(props.newFlg);

  // メニューを開く処理
  const handleClick = (event) => {
    const currentTarget = event.currentTarget;
    restApi.get('/api/task/notices', (data) => {
      setNewComments(data.notices);
      setNewFlg(data.notices.some((x) => x.NEW_FLG == 1));
      setAnchorEl(currentTarget); // クリックしたボタンを基準にメニューを表示
    });
  };

  useEffect(() => {
    setNewFlg(props.newFlg);
  }, [props.newFlg]);

  // メニューを閉じる処理
  const handleClose = () => {
    setAnchorEl(null); // メニューを非表示
  };

  // メニューを選択
  const handleOnClickMenuItem = (card) => {
    props.callEditModal(card);
    setAnchorEl(null); // メニューを非表示
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Badge color="error" variant="dot" invisible={!newFlg}>
          <NotificationsNoneOutlinedIcon style={{ fontSize: 26 }} />
        </Badge>
      </IconButton>
      {/* メニューの定義 */}
      <Menu
        anchorEl={anchorEl} // メニューの表示位置
        open={Boolean(anchorEl)} // メニューの開閉を管理
        onClose={handleClose} // メニューを閉じる処理
        anchorOrigin={{
          vertical: 'bottom', // メニューの表示位置をボタンの下に設定
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {newComments.map((x, i) => (
          <MenuItem
            key={i}
            onClick={() => {
              handleOnClickMenuItem(x);
            }}
            className="p-1"
          >
            <div className="newcomments">
              {/* メニューアイテムのタイトル横にも NEW_FLG=1 の場合に赤ドット */}
              {x.NEW_FLG == 1 && <span className="new-dot" aria-label="new" />}
              {x.TITLE}
              <span>
                <div style={{ fontSize: '8pt' }}>
                  <b>{x.TAN_NAME}</b>さん
                  {x.HISTORY_TYPE === HISTORY_TYPE.ADD_COMMENT ? 'がコメントしました' : ''}
                  <span style={{ fontSize: '10pt' }} className="pl-2">
                    &nbsp;{x.INS_DATE}&nbsp;{x.INS_TIME}
                  </span>
                </div>
                <div className="newcomments-item">{x.HISTORY_CONTENT}</div>
              </span>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default TaskNewNotificationButtonIcon;
